<template>
  <v-stepper v-model="step">
    <v-stepper-header dense depressed>
      <v-stepper-step :complete="!!student.id" editable step="1" v-if="!lead.student">Chọn Học Viên</v-stepper-step>
      <v-stepper-step :complete="!!student.majors" v-if="!lead.student" editable step="2">Cấu Hình</v-stepper-step>
      <v-stepper-step editable step="3">Duyệt Đơn</v-stepper-step>
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content class="stepper" step="1">
        <find-student :lead="lead" :student.sync="student" @complete="go(2)" />
      </v-stepper-content>
      <v-stepper-content class="stepper" step="2">
        <settup-course :student.sync="student" @back="go(1)" @complete="go(3)" />
      </v-stepper-content>
      <v-stepper-content class="stepper" step="3">
        <add-to-class :student.sync="student" :lead="lead" @complete="close()" />
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import FindStudent from '@/modules/lead/stepper/FindStudent.vue'
import SettupCourse from '@/modules/lead/stepper/SettupCourse.vue'
import AddToClass from '@/modules/lead/stepper/AddToClass.vue'
import { Student } from '@/plugins/api'
export default {
  components: {
    FindStudent,
    SettupCourse,
    AddToClass
  },
  props: {
    lead: Object
  },
  data () {
    return {
      step: 1,
      loading: false,
      dialog: false,
      student: {}
    }
  },
  computed: {},
  methods: {
    selectStudent () {},
    async reset () {
      this.student = this.lead.student || {}
      if (this.student.id) {
        this.step = 3
        this.student = await Student.fetchOne(this.student.id)
      } else {
        this.step = 1
      }
    },
    updateStudent (student) {
      this.student = student
    },
    go (step) {
      this.step = step
    },
    close () {
      this.reset()
      this.$emit('close')
    }
  },
  created: function () {
    this.reset()
  },
  filters: {},
  watch: {
    lead () {
      this.reset()
    }
  }
}
</script>
<style>
.v-stepper__header {
  flex-wrap: nowrap !important;
}
.stepper {
  height: 570px;
}
.v-stepper__wrapper {
  height: 100%;
  position: relative;
}
</style>
